import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uix/uix/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faq"
    }}>{`FAQ`}</h1>
    <p>{`We are trying to make your experience as smooth as possible. However, there are still some issues that you may face while working with UI Extensibility.`}</p>
    <h2 {...{
      "id": "aio-cli-does-not-behave-as-described-in-the-documentation"
    }}>{`AIO CLI does not behave as described in the documentation`}</h2>
    <p>{`Most probably you have a dated version of AIO CLI.`}</p>
    <p><strong parentName="p">{`Solution`}</strong></p>
    <p>{`Ensure your CLI and all plugins are up to date.`}</p>
    <p>{`Check the installed version of AIO CLI:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`aio -v
`}</code></pre>
    <p>{`Compare it with the current published version:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm show @adobe/aio-cli version
`}</code></pre>
    <p>{`If your CLI is outdated, update it by running:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install -g @adobe/aio-cli
`}</code></pre>
    <p>{`After that, you can simply run `}<inlineCode parentName="p">{`aio update`}</inlineCode>{` to ensure all plugins are updated.`}</p>
    <p>{`Find more details on `}<a parentName="p" {...{
        "href": "../../guides/local-environment"
      }}>{`Prepare your local environment`}</a>{`.`}</p>
    <h2 {...{
      "id": "my-ui-extension-is-not-loaded"
    }}>{`My UI Extension is not loaded`}</h2>
    <p>{`Most probably you have issues with a SSL certificate. Adobe App Builder generates valid certificates for the production environment but during local development and on staging you may need manually accept the certificate.`}</p>
    <p><strong parentName="p">{`Solution`}</strong></p>
    <ol>
      <li parentName="ol">{`Open a UI Extension endpoint in your browser (e.g. `}<inlineCode parentName="li">{`https://localhost:9080`}</inlineCode>{` during local development).`}</li>
      <li parentName="ol">{`Manually accept the certificate. For example for Google Chrome type `}<inlineCode parentName="li">{`thisisunsafe`}</inlineCode>{` or click on `}<inlineCode parentName="li">{`Advanced`}</inlineCode>{` link and then on `}<inlineCode parentName="li">{`Proceed to localhost (unsafe)`}</inlineCode>{`.`}</li>
    </ol>
    <h2 {...{
      "id": "login-via-aio-login-does-not-work-or-aio-app-commands-show-the-wrong-ims-organization-or-projects"
    }}>{`Login via `}<inlineCode parentName="h2">{`aio login`}</inlineCode>{` does not work or `}<inlineCode parentName="h2">{`aio app`}</inlineCode>{` commands show the wrong IMS organization or projects`}</h2>
    <p>{`This sometimes may happen to users who work with multiple Adobe Services and are members of multiple IMS organizations.`}</p>
    <p><strong parentName="p">{`Solution`}</strong></p>
    <ol>
      <li parentName="ol">{`Go to `}<a parentName="li" {...{
          "href": "https://account.adobe.com"
        }}>{`https://account.adobe.com`}</a>{` and click "Sign Out". `}</li>
      <li parentName="ol">{`Open the terminal and type `}<inlineCode parentName="li">{`aio logout`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Then try to run `}<inlineCode parentName="li">{`aio login`}</inlineCode>{` again.`}</li>
    </ol>
    <h2 {...{
      "id": "what-ui-can-be-extended"
    }}>{`What UI can be extended`}</h2>
    <p>{`You may find a list of Adobe Services that implement UI Extensibility under `}<inlineCode parentName="p">{`Extensible Services`}</inlineCode>{` in this documentation. For each service, we provide documentation of extension points and step-by-step guides.`}</p>
    <h2 {...{
      "id": "what-is-an-extension-point"
    }}>{`What is an extension point`}</h2>
    <p>{`The extension point is functionality in Adobe Service UI that allows the execution of 3rd party code. Extension point usually includes:`}</p>
    <ol>
      <li parentName="ol">{`Requirements for extension implementation (what API extension should implement).`}</li>
      <li parentName="ol">{`Promise to invoke extension code under defined conditions.`}</li>
      <li parentName="ol">{`API that allows the extension to access Adobe Service UI functionality.`}</li>
    </ol>
    <h2 {...{
      "id": "what-software-tools-should-i-have-installed-to-get-started-with-developing"
    }}>{`What software tools should I have installed to get started with developing`}</h2>
    <p>{`You will need NodeJS and `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aio-cli"
      }}>{`AIO CLI`}</a>{`. All other tools are optional and you may replace them with your preferred one.`}</p>
    <p>{`For more information see `}<a parentName="p" {...{
        "href": "../../guides/local-environment/"
      }}>{`Set Up Local Environment`}</a>{`.`}</p>
    <h2 {...{
      "id": "do-i-need-to-deploy-any-services-locally"
    }}>{`Do I need to deploy any services locally`}</h2>
    <p>{`No! The only thing that you will run locally is your own extension. You will be able to add your extension running locally or in Adobe cloud to the production Adobe Services and see how it behaves before sharing it with anybody else.`}</p>
    <h2 {...{
      "id": "can-i-test-my-extension-before-deploying-it-to-the-cloud"
    }}>{`Can I test my extension before deploying it to the cloud`}</h2>
    <p>{`Yes! It is possible to run the extension locally and embed it into production Adobe Service to check if it works as expected.
For more information see `}<a parentName="p" {...{
        "href": "../../services/aem-cf-console-admin/debug"
      }}>{`Troubleshooting`}</a>{`.`}</p>
    <h2 {...{
      "id": "should-i-write-all-extension-code-by-myself"
    }}>{`Should I write all extension code by myself`}</h2>
    <p>{`No! We provide a template that allows you to generate most of the code required to make UI Extension out of the App Builder application. You will need only implement your business logic.`}</p>
    <p>{`But you still can write everything from scratch if you wish to.`}</p>
    <p>{`For more information see `}<a parentName="p" {...{
        "href": "../../services/aem-cf-console-admin/code-generation/"
      }}>{`Code Generation`}</a>{`.`}</p>
    <h2 {...{
      "id": "what-is-the-simplest-way-to-start"
    }}>{`What is the simplest way to start`}</h2>
    <p>{`Our `}<a parentName="p" {...{
        "href": "../../services/aem-cf-console-admin/code-generation/"
      }}>{`code generator`}</a>{` supplies a demo project that you may generate and deploy for your IMS organization. Explore it and change to learn what is possible with UI Extensibility.`}</p>
    <h2 {...{
      "id": "how-i-can-ask-for-additional-extension-point"
    }}>{`How I can ask for additional extension point`}</h2>
    <p>{`We are open to genuine feedback and would gladly expand UI Extensibility capability to solve your needs.`}</p>
    <p>{`Please get in touch with us through email at `}<a parentName="p" {...{
        "href": "mailto:uix@adobe.com"
      }}>{`uix@adobe.com`}</a>{` for feature requests, use-case validation, assistance with extension implementation, or bug reports.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      